const getWorkbookName = (card) => {
  const reptSource = card?.reptSource;
  if (!reptSource) return '';
  return String(reptSource).split('/')[0].trim();
};

export const resolveSmartCardTitle = (card, fallbackTitle = '') => {
  const displayText = card?.displayText ? String(card.displayText).trim() : '';
  if (displayText) return displayText;

  const workbookName = getWorkbookName(card);
  if (workbookName) return workbookName;

  return fallbackTitle;
};
